<template>
  <div class="content" style="position: relative;">
    <EChart
      class="chart"
      ref="chart"
      :options="option"
      :width="`${size}px`"
      :height="`${size}px`"
    ></EChart>
    <div class="innerContent">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import EChart from "@/common/echart";
//var myChart;
export default {
  data() {
    return {
      option: {
        color: ["#244b66", "#AFC3D6"],
        series: [
          {
            type: "pie",
            radius: ["85%", "100%"],
            title: {
              show: false,
            },
            data: [
              {
                value: 20,
                label: {
                  position: "center",
                  color: "#244b66",
                  fontSize: 65,
                },
              },
              {
                value: 80,
              },
            ],
          },
        ],
      },
    };
  },
  components: { EChart },
  props: {
    value: { type: Number, required: true },
    color:{type:String},
    size:{type:Number, default:250}
  },
  watch: {
    value: {
      handler(val) {
        this.setChartOpt(val);
      },
    },
  },
  mounted() {
    //const container = this.$refs.chart;
    //myChart = new Charts(container);
    this.setChartOpt();
  },
  methods: {
    setChartOpt(val) {
      val = val || this.value;
      var newOpt = Object.assign({}, this.option);
      var it = newOpt.series[0];
      it.data[0].value = val;
      it.data[1].value = 100 - val;
      newOpt.color[0] = this.color;
      this.option = newOpt;
      //myChart.setOption(this.option);
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-line {
  margin: 10px 0;
  align-items: baseline;
  color: #244b66;
  font-size: 60px;
}
.innerContent{
  position: absolute;
  left: 0;
  right:0;
  top:0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.idxNumOut {
  width: 90px;
  height: 90px;
  border-radius: 100%;
  border: 2px solid white;
  background: transparent;
  padding: 10px;
  margin: 0 20px;
  .idxNum {
    width: 70px;
    height: 70px;
    font-size: 50px;
    border-radius: 100%;
    color: white;
    line-height: 70px;
    text-align: center;
  }
}
.name {
  font-size: 40px;
  color: #697c94;
}
.barbg {
  margin: 0 20px;
  width: 900px;
  height: 16px;
  border-radius: 8px;
  background-color: #bdccd8;

  .bar {
    height: 16px;
    border-radius: 8px;
  }
}
.chart {
  width: 250px;
  height: 250px;
  margin: 30px 20px;
}
.value {
  width: 250px;
  text-align: right;
}
</style>
